import { simpleGqlClient } from '@/graphql/simple-client.jsx';

const q = async (query, variables = {}) => {
  const result = await simpleGqlClient.query(query, variables);
  if (result.errors?.length) throw new Error(result.errors[0].message);
  return result.data;
};

const m = async (query, variables = {}) => {
  const result = await simpleGqlClient.mutation(query, variables);
  if (result.errors?.length) throw new Error(result.errors[0].message);
  return result.data;
};

export const cotizarGuia = (input) => q(
  `query($input: CotizarGuiaInput!) {
    cotizarGuia(input: $input) {
      importe_sugerido tarifario_id mensaje desglose { tipo_regla importe detalle }
    }
  }`,
  { input },
).then((d) => d.cotizarGuia);

export const aplicarImporteFacturadoDesdeSugerido = (guia_id) => m(
  `mutation($guia_id: Int!) {
    aplicarImporteFacturadoDesdeSugerido(guia_id: $guia_id)
  }`,
  { guia_id: Number(guia_id) },
).then((d) => d.aplicarImporteFacturadoDesdeSugerido);

export const overrideImporteFacturado = ({ guia_id, importe_facturado, motivo }) => m(
  `mutation($input: OverrideImporteFacturadoInput!) {
    overrideImporteFacturado(input: $input)
  }`,
  { input: { guia_id: Number(guia_id), importe_facturado: Number(importe_facturado), motivo } },
).then((d) => d.overrideImporteFacturado);
